import { slicedToArray as _slicedToArray, typeof as _typeof } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useRef, useState, useEffect } from 'react';
import { LanguageModalBody } from './LanguageModalBody.Legacy.js';
import { i18n } from '../../../i18n/translate.js';
import { sanitizeUrl } from '@braintree/sanitize-url';
import { FAIcon } from '../../fa-icon/component.js';
import { WindowHelperWrapper } from '../../../utils/WindowHelper.js';
var LanguageModal = function LanguageModal(_ref) {
  var appendLanguage = _ref.appendLanguage,
    enforceSelection = _ref.enforceSelection,
    languages = _ref.languages,
    onConfirmSelection = _ref.onConfirmSelection,
    selectedLanguage = _ref.selectedLanguage,
    showLanguageModal = _ref.showLanguageModal,
    title = _ref.title,
    toggleLanguageModal = _ref.toggleLanguageModal;
  var containerRef = useRef(null);
  var _useState = useState(selectedLanguage),
    _useState2 = _slicedToArray(_useState, 2),
    selected = _useState2[0],
    setSelected = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setLoading = _useState4[1];
  var windowHelper = WindowHelperWrapper();
  useEffect(function () {
    isLoading && containerRef && containerRef.current && setLoading(false);
  }, [isLoading]);
  useEffect(function () {
    i18n && i18n.loadTranslations();
  }, []);
  var confirmSelection = function confirmSelection() {
    var _languages$selected;
    if (typeof window === 'undefined') {
      return;
    }
    onConfirmSelection && onConfirmSelection(selected);
    toggleLanguageModal();
    localStorage.removeItem('languageChecked');
    if (!appendLanguage && (_languages$selected = languages[selected]) !== null && _languages$selected !== void 0 && _languages$selected.translation_url) {
      var _languages$selected2;
      windowHelper.redirect(sanitizeUrl((_languages$selected2 = languages[selected]) === null || _languages$selected2 === void 0 ? void 0 : _languages$selected2.translation_url));
    } else {
      var currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('locale', selected.replace('_', '-'));
      windowHelper.redirect(encodeURI(sanitizeUrl(currentUrl.toString())));
    }
  };
  var onClose = function onClose() {
    setSelected(selectedLanguage);
    toggleLanguageModal();
  };
  var renderedTitle = /*#__PURE__*/React.createElement("span", {
    className: "h2"
  }, /*#__PURE__*/React.createElement(FAIcon, {
    icon: "language",
    additionalClasses: "m-r-10"
  }), title || i18n.t('Choose Your Language'));
  if (!languages) return null;
  if (_typeof(languages) !== 'object' || Object.keys(languages).length <= 0) return null;
  var confirmButtonDisabled = !enforceSelection && selected === selectedLanguage;
  return /*#__PURE__*/React.createElement("div", {
    ref: containerRef,
    className: "foundry"
  }, /*#__PURE__*/React.createElement(LanguageModalBody, {
    buttonDisabled: confirmButtonDisabled,
    ref: !isLoading ? containerRef.current : null,
    renderedTitle: renderedTitle,
    onClose: onClose,
    showLanguageModal: showLanguageModal,
    enforceSelection: enforceSelection,
    languages: languages,
    confirmSelection: confirmSelection,
    selected: selected,
    setSelected: setSelected
  }));
};
LanguageModal.displayName = "LanguageModal";
export { LanguageModal };